import { gql } from '@apollo/client';

export const PREP_MODE_SECTION_IS_DONE = gql`
  fragment PrepModeSectionIsDone on PrepModeSection {
    isDone
  }
`;
